<template>
  <router-view />
</template>

<script setup>
import { onMounted, onBeforeUnmount } from "vue";
import { useNotificationStore } from "@/stores/notifications";
import router from "@/router";

function getAuthToken() {
  const match = document.cookie.match(/(?:^|; )auth_token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

const notificationStore = useNotificationStore();
let stopAfterEach;

function syncPolling() {
  if (getAuthToken()) {
    notificationStore.startPolling();
  } else {
    notificationStore.stopPolling();
  }
}

function refreshCountIfVisible() {
  if (document.hidden || !getAuthToken()) return;
  notificationStore.fetchUnreadCount({ silent: true });
}

onMounted(() => {
  syncPolling();
  stopAfterEach = router.afterEach(syncPolling);
  window.addEventListener("focus", refreshCountIfVisible);
  document.addEventListener("visibilitychange", refreshCountIfVisible);
});

onBeforeUnmount(() => {
  stopAfterEach?.();
  window.removeEventListener("focus", refreshCountIfVisible);
  document.removeEventListener("visibilitychange", refreshCountIfVisible);
  notificationStore.stopPolling();
});
</script>

<script>
import feather from "feather-icons";

export default {
  mounted() {
    feather.replace();
  },
};
</script>
